import { ColorButton } from "./button";
import { H2 } from "./h";

type ConfirmMessageProps = {
    isOpen: boolean,
    title: string,
    message: string,
    onCancel: () => void,
    onConfirm: () => void,
}

export function ConfirmMessage({ isOpen, title, message, onCancel, onConfirm }: ConfirmMessageProps) {
    if (!isOpen) return null;

    return (
        <div>
            <div className={`fixed flex flex-col p-4 gap-6 
                    top-1/2 -translate-y-1/2 left-1/2 -translate-x-1/2 z-30 rounded-md shadow-lg bg-silver-100 dark:bg-silver-500`}>

                <div className="flex flex-col p-4 gap-3 justify-center items-center">
                    <div className="flex flex-col gap-2">
                        <H2>{title}</H2>
                        <p>{message}</p>
                    </div>
                    <div className="flex p-2 gap-10">
                        <ColorButton onClick={onCancel}>
                            Cancelar
                        </ColorButton>
                        <ColorButton onClick={onConfirm}>
                            Confirmar
                        </ColorButton>
                    </div>
                </div>
            </div>
            <div className="fixed w-screen h-screen top-0 left-0 z-10 bg-black/10" />
        </div>
    )
}